/* eslint-disable react/jsx-pascal-case */
import { Col, ConfigProvider, Form, Input, Row, Button, Space, Card, InputNumber, DatePicker } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { CloseOutlined } from '@ant-design/icons';
import { useBillPaymentClass } from "../controller/BillPaymentClassController";
import { useUnitType } from "../../UnitType/controller/UnitTypeController";
import dayjs from 'dayjs';

// import Label_language from '../../language'
const { ConfigContext } = ConfigProvider

const BillPaymentClassForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
        classId = null,
        setClassId = ()=>{}
    }
) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0)
    const [calculateLoading, setCalculateLoading] = useState(false)
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        setiUnitType(UnitTypeOption)
        if (classId !== null){
            let newBillPaymentClassOption = BillPaymentClassOption?.filter(item=>{
                if(item.class_id === classId){
                    return item
                } 
            })
            setClassData(newBillPaymentClassOption)
        }else{
            setClassData(BillPaymentClassOption)
        }
    }
    const onFinish = (values) => {
        let year = dayjs(values?.year).format("YYYY")
        onFormFinish({
            ...values,
            year
        })
    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
        
    }
    const getClassDataField = (field, name, count) => {
        let classDatas = []
        if (propsForm) {
            classDatas = propsForm.getFieldValue("class_data")
        }
        else {
            classDatas = form.getFieldsValue("class_data")
        }
        let classData = classDatas[field]
        let value = ""
        if (classData) {
            if (name === "name") {
                value = `${classData[name]}-${classData["name_serial"]}`

            }
            else {
                value = classData[name]
            }
        }
        return value
    }
    const setClassData = (classDatas) => {
        let iValue = 0
        if (propsForm) {
            iValue = propsForm.getFieldValue("iValue")
        }
        else {
            iValue = form.getFieldValue("iValue")
        }
        let newClassData = classDatas
            .map((classData) => {
                console.log({classData})
                let grade_class_data = classData?.grade_class_data
                let grade_class_first_data = grade_class_data.find(ele => true)
                let grade_class_id = grade_class_first_data?.grade_class_id
                let bill_payment_grade_class_datas = grade_class_first_data?.bill_payment_grade_class_data
                let temp = bill_payment_grade_class_datas
                let bill_payment_grade_class_latest_data = [...temp].pop()
                let payment_time_end_date = bill_payment_grade_class_latest_data?.payment_time_end ?? null
                let payment_time_start = dayjs().add(1, 'day')
                if (!!payment_time_end_date) {
                    payment_time_start = dayjs(payment_time_end_date, "YYYY-MM-DD").add(1, 'day')
                }
                return {
                    ...classData,
                    grade_class_id,
                    // iValue: iValue,
                    iValue: classData?.default_class_count || 32,
                    payment_time_start: payment_time_start,
                    default_class_count: classData?.default_class_count || 32
                }
               
            })
        if (propsForm) {
            propsForm.setFieldValue("class_data", newClassData)
        }
        else {
            form.setFieldValue("class_data", newClassData)
        }
    }
    const setiUnitType = (UnitTypes) => {
        let UnitTypeFirst = UnitTypes.find(ele => true)
        let iUnitID = UnitTypeFirst?.iUnitID
        let iValue = UnitTypeFirst?.iValue
        if (propsForm) {
            propsForm.setFieldValue("iUnitID", iUnitID)
            propsForm.setFieldValue("iValue", iValue)
        }
        else {
            form.setFieldValue("iUnitID", iUnitID)
            form.setFieldValue("iValue", iValue)
        }
    }
    const comfirmGetAmount = () => {
        if (propsForm) {
            propsForm
                .validateFields()
                .then((values) => {
                    let data = packageAmountData(values)
                    setCalculateLoading(true)
                    calculateBillPaymentClass(data)
                })
                .catch((info) => {
                });
        }
        else {
            form
                .validateFields()
                .then((values) => {
                    let data = packageAmountData(values)
                    setCalculateLoading(true)
                    calculateBillPaymentClass(data)

                })
                .catch((info) => {
                });
        }

    }
    const packageAmountData = (values) => {
        let class_datas = values?.class_data
        let data = class_datas.map((class_data) => {
            return {
                grade_class_id: class_data?.grade_class_id,
                year: dayjs(values?.year).format("YYYY"),
                payment_time_start: dayjs(class_data?.payment_time_start).format("YYYY-MM-DD"),
                amount: values?.amount,
                iUnitID: values?.iUnitID,
                iValue: class_data?.iValue,
            }
        })
        return data
    }
    const onBillPaymentClassFinish = ({ axiosMode, status, values }) => {
        if (axiosMode === "postCalculate") {
            let calculateDatas = values?.data
            let formValues = []
            let calculate_year
            if (propsForm) {
                calculate_year = propsForm.getFieldValue("year")
                formValues = propsForm.getFieldValue("class_data")
            }
            else {
                calculate_year = form.getFieldValue("year")
                formValues = form.getFieldValue("class_data")
            }
            calculate_year = dayjs(calculate_year).format("YYYY")
            let newCalculateDatas = calculateDatas.map((calculateData, index) => {
                let classData = formValues[index]
                let grade_class_data = classData?.grade_class_data
                let grade_class_first_data = grade_class_data.find(ele => true)
                let bill_payment_grade_class_datas = grade_class_first_data?.bill_payment_grade_class_data
                let base_year_serial = 0
                bill_payment_grade_class_datas.forEach(element => {
                    if (element.year === parseInt(calculate_year)) {
                        base_year_serial += 1
                    }
                });
                let datas = calculateData?.data.map((data) => {
                    let payment_time = []
                    let payment_time_start_string = data?.payment_time_start
                    let payment_time_end_string = data?.payment_time_end
                    if (payment_time_start_string && payment_time_end_string) {
                        let payment_time_start = dayjs(payment_time_start_string, "YYYY-MM-DD")
                        let payment_time_end = dayjs(payment_time_end_string, "YYYY-MM-DD")
                        payment_time = [payment_time_start, payment_time_end]
                    }
                    return {
                        year_serial: base_year_serial + data?.year_serial,
                        payment_time: payment_time
                    }
                })

                return {
                    ...formValues[index],
                    data: datas
                }
            })
            if (propsForm) {
                propsForm.setFieldValue("class_data", newCalculateDatas)
            }
            else {
                form.setFieldValue("class_data", newCalculateDatas)
            }
            setCalculateLoading(false)
        }
    }
    const {
        getBillPaymentClassOption,
        BillPaymentClassOption,
        calculateBillPaymentClass
    } = useBillPaymentClass({
        onBefore: () => { },
        onFinish: onBillPaymentClassFinish
    })
    
    const {
        getUnitTypeOption,
        UnitTypeOption
    } = useUnitType({
        onBefore: () => { },
        onFinish: () => { }
    })

    useEffect(() => {
        setDataInitialization()
        getBillPaymentClassOption()
        getUnitTypeOption({
            cName: '期',
        })
    }, [formReloadCount])

    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [])
    useEffect(() => {
        setDataInitialization()
    }, [BillPaymentClassOption, UnitTypeOption])

    

    return (
        <Row>
            <Col span={24}>
                <Form
                    // layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Row gutter={[4, 4]}>
                                <Col span={8}>
                                    <Form.Item
                                        label={"年度"}
                                        name={"year"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]}
                                    >
                                        <DatePicker.YearPicker />
                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label={"新增期數"}
                                        name={"amount"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]}
                                    >
                                        <InputNumber min={1} />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Button
                                        type='primary'
                                        onClick={() => {
                                            comfirmGetAmount()
                                        }}
                                        loading={calculateLoading}
                                    >
                                        進行試算
                                    </Button>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label={"iUnitID"}
                                        name={"iUnitID"}
                                        hidden={true}

                                    >
                                        <InputNumber min={1} />
                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label={"iValue"}
                                        name={"iValue"}
                                        hidden={true}
                                    >
                                        <InputNumber min={1} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Form.List name="class_data">
                                    {(fields, { add, remove }) => (

                                        <Col span={24}
                                        >
                                            <Row gutter={[4, 4]}>
                                                {fields.map((field) => (
                                                    <Col span={24}>
                                                        <Card
                                                            size="small"
                                                            title={getClassDataField(field.name, "name", count)}
                                                            key={field.key}
                                                            extra={
                                                                <CloseOutlined
                                                                    onClick={() => {
                                                                        remove(field.name);
                                                                    }}
                                                                />
                                                            }
                                                        >
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Row gutter={[4, 4]}>
                                                                        <Col>
                                                                            <Form.Item
                                                                                label="name"
                                                                                name={[field.name, 'name']}
                                                                                hidden
                                                                            >
                                                                                <InputNumber min={1} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col>
                                                                            <Form.Item
                                                                                label="grade_class_id"
                                                                                name={[field.name, 'grade_class_id']}
                                                                                hidden

                                                                            >
                                                                                <InputNumber min={1} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col>
                                                                            <Form.Item
                                                                                label="每期堂數"
                                                                                name={[field.name, 'iValue']}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "請輸入"
                                                                                    }
                                                                                ]}

                                                                            >
                                                                                <InputNumber min={1} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col>
                                                                            <Form.Item
                                                                                label="開始日期"
                                                                                name={[field.name, 'payment_time_start']}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "請輸入"
                                                                                    }
                                                                                ]}
                                                                            >
                                                                                <DatePicker format={'YYYY-MM-DD'} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col>
                                                                            <Form.Item
                                                                                label="預設每期堂數"
                                                                                name={[field.name, 'default_class_count']}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "請輸入"
                                                                                    }
                                                                                ]}
                                                                            >
                                                                                <InputNumber min={1} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Form.List
                                                                        name={[field.name, 'data']}
                                                                    >
                                                                        {(subFields, subOpt) => (
                                                                            <Row gutter={[8, 8]}>
                                                                                {subFields.map((subField) => (
                                                                                    <Col span={24}>
                                                                                        <Space
                                                                                            wrap
                                                                                            key={subField.key}
                                                                                            align='start'
                                                                                        >

                                                                                            <Form.Item

                                                                                                label='期'
                                                                                                name={[subField.name, 'year_serial']}
                                                                                            >
                                                                                                <InputNumber
                                                                                                    disabled={true}
                                                                                                />
                                                                                            </Form.Item>
                                                                                            <Form.Item
                                                                                                label={"上課區間"}
                                                                                                name={[subField.name, 'payment_time']}
                                                                                            >
                                                                                                <DatePicker.RangePicker format={'YYYY-MM-DD'} />
                                                                                            </Form.Item>

                                                                                            <CloseOutlined
                                                                                                onClick={() => {
                                                                                                    subOpt.remove(subField.name);
                                                                                                }}
                                                                                            />
                                                                                        </Space>
                                                                                    </Col>
                                                                                ))}
                                                                                {/* <Button type="dashed" onClick={() => subOpt.add()} block>
                                                                                    + 新增一期
                                                                                </Button> */}
                                                                            </Row>

                                                                        )}
                                                                    </Form.List>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                ))}
                                                {/* <Col span={24}>
                                                    <Button type="dashed" onClick={() => add()} block>
                                                        + 新增班級
                                                    </Button>
                                                </Col> */}
                                            </Row>

                                        </Col>

                                    )}
                                </Form.List>
                            </Row>

                        </Col>

                    </Row>
                </Form >
            </Col >
        </Row >


    )
}


export default BillPaymentClassForm;
